import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  DirectionsRenderer,
} from "react-google-maps";
import {
  GOOGLE_MAPS_URL,
  GOOGLE_MAPS_STYLE,
  KIND_COLORS_BY_HASH,
  PARAMETER_MAP_COORDINATES,
} from "constants/CustomConstants";
import { Radio } from "antd";
import {
  get,
  filter,
  split,
  forEach,
  isEmpty,
  toUpper,
  uniq,
  indexOf,
  remove,
  head,
  last,
} from "lodash";
import { useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";

import ProductCard from "components/product/card/ProductCard";

import styles from "components/product/map/ProductMap.module.scss";
import {useTranslation} from "next-i18next";
import find from "lodash/find";
import PlaceCard from "components/pages/srandon/card/PlaceCard";

const Map = withScriptjs(
  withGoogleMap((props) => {
    const { t } = useTranslation();
    const { markers, mapCenter, directionsOrigin, isSrandon } = props;
    const [openedInfoWindows, setOpenedInfoWindow] = useState([]);
    const [directions, setDirections] = useState({
      fetched: false,
      directions: false,
      origin: false,
    });

    const generateDirections = (markers, origin) => {
      if (!origin) {
        origin = get(head(markers), "position");
      }
      const destination = get(last(markers), "position");
      const waypoints = [];
      forEach(markers, function (marker, index) {
        if (index < markers.length - 1) {
          waypoints.push({ location: get(marker, "position") });
        }
      });

      const directionsService = new google.maps.DirectionsService();
      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode.WALKING,
          waypoints: waypoints,
          optimizeWaypoints: true,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            setDirections({
              fetched: true,
              directions: result,
              origin: directionsOrigin,
            });
          } else {
            setDirections({
              fetched: true,
              directions: false,
              origin: directionsOrigin,
            });
            alert(t("Nepodarilo sa vygenerovať trasu"));
          }
        }
      );
    };

    if (
      directionsOrigin &&
      !isEmpty(markers) &&
      (!directions.fetched || directions.origin != directionsOrigin)
    ) {
      switch (directionsOrigin) {
        case "current":
          if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              generateDirections(markers, {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              });
            });
          } else {
            alert(t("Vašu polohu nie je možné určiť."));
          }
          break;
        case "center":
          generateDirections(markers, { lat: 48.377721, lng: 17.5859849 });
          break;
        case "bus":
          generateDirections(markers, { lat: 48.3703912, lng: 17.583152 });
          break;
        case "train":
          generateDirections(markers, { lat: 48.3704879, lng: 17.5846489 });
          break;
      }
    }

    return (
      <GoogleMap
        defaultZoom={isSrandon ? 11 : 16}
        defaultCenter={isSrandon ? { lat: 48.3704879, lng: 17.5846489 } : mapCenter}
        defaultOptions={{
          styles: GOOGLE_MAPS_STYLE,
        }}
      >
        {markers.map((marker, index) => (
          <Marker
            key={`map-product-marker-${marker.productId}-${index}`}
            position={marker.position}
            icon={marker.icon}
            onClick={function () {
              if (indexOf(openedInfoWindows, marker.productId) >= 0) {
                setOpenedInfoWindow(
                  remove(openedInfoWindows, marker.productId)
                );
              } else {
                setOpenedInfoWindow(
                  uniq([...openedInfoWindows, marker.productId])
                );
              }
            }}
          >
            {indexOf(openedInfoWindows, marker.productId) >= 0 ? (
              <InfoWindow>
                {isSrandon ? (
                  <div style={{ width: "500px" }}>
                    <PlaceCard product={marker.product} />
                  </div>
                ) : (
                  <div style={{ width: "200px" }}>
                    <ProductCard {...marker.product} />
                  </div>
                )}
              </InfoWindow>
            ) : (
              ""
            )}
          </Marker>
        ))}
        {directions.directions ? (
          <DirectionsRenderer
            directions={directions.directions}
            options={{
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: "#FBD136",
                strokeOpacity: 1,
                strokeWeight: 3,
              },
            }}
          />
        ) : (
          ""
        )}
      </GoogleMap>
    );
  })
);

const ProductMap = (props) => {
  const {
    products,
    parametersKey = "detailedParameters",
    showTitle = true,
    showDirections = false,
    showDownload = false,
    containerElement = <div style={{ height: `220px` }} />,
    isSrandon = false,
    category = ""
  } = props;
  const { t } = useTranslation();

  if (typeof window === "undefined" || isEmpty(products)) {
    return "";
  }

  const [directionsOrigin, setDirectionsOrigin] = useState(false);

  let markers = [];
  let mapCenter = {};

  forEach(products, function (product, index) {
    if (
      filter(get(product, parametersKey, []), function (param) {
        return param.hash == PARAMETER_MAP_COORDINATES;
      }).length == 1
    ) {
      var mapCoordinates = split(
        get(
          filter(get(product, parametersKey, []), function (param) {
            return param.hash == PARAMETER_MAP_COORDINATES;
          }),
          "[0].value"
        ),
        ","
      );

      let fillColor = get(
        KIND_COLORS_BY_HASH,
        get(product, "kind.hash", "default"),
        "#000"
      );

      if(isSrandon){
        let productCategory = get(product, "categories[2].urlName");
        fillColor = get(find(get(category, "childCategories"), { "urlName": productCategory}), "hash");

      }

      let svg =
        '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="' +
        fillColor +
        '" d="M7.98859 3.19923C6.04068 -0.243231 1.58888 0.659012 1.05622 3.81106C0.4769 7.25352 4.48547 10.9361 7.98859 13C11.4917 10.9361 15.6247 7.26901 14.921 3.81106C14.2794 0.678373 9.93649 -0.243231 7.98859 3.19923Z" stroke="black" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /></svg>';

      if(isSrandon){
        svg = `<svg width="20" height="24" viewBox="0 0 40 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.5312 0C8.77903 0 0.03125 8.26443 0.03125 18.4225C0.03125 31.1902 19.5504 53 19.5504 53C19.5504 53 39.0312 30.5623 39.0312 18.4225C39.0312 8.26443 30.2838 0 19.5312 0ZM25.4148 23.8167C23.7925 25.349 21.662 26.1154 19.5312 26.1154C17.4008 26.1154 15.2697 25.349 13.648 23.8167C10.4037 20.752 10.4037 15.7651 13.648 12.7001C15.219 11.2153 17.3087 10.3975 19.5312 10.3975C21.7538 10.3975 23.8432 11.2156 25.4148 12.7001C28.6591 15.7651 28.6591 20.752 25.4148 23.8167Z" fill="${fillColor ? fillColor : "#000"}"/>
        </svg>`
      }

      if (mapCoordinates.length == 2) {
        const markerData = {
          position: {
            lat: parseFloat(mapCoordinates[0]),
            lng: parseFloat(mapCoordinates[1]),
          },
          icon: {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
          },
          productId: product.id,
          product: product,
        };

        markers.push(markerData);
        if (index == 0) {
          mapCenter = markerData.position;
        }
      }
    }
  });

  if (markers.length == 0) {
    return "";
  }

  return (
    <>
      {showTitle ? <h3 className={styles.title}>{t("Ako sa sem dostať")}</h3> : ""}
      {showDirections ? (
        <div className={styles.navigationRow}>
          <div className={styles.label}>{t("Zvoľte počiatočný bod")}:</div>

          <Radio.Group
            onChange={(e) => {
              setDirectionsOrigin(e.target.value);
            }}
            value={directionsOrigin}
            className={styles.navigationSelect}
          >
            {navigator && navigator.geolocation ? (
              <Radio value={`current`}>{t("Moja aktuálna poloha")}</Radio>
            ) : (
              ""
            )}
            <Radio value={`center`}>{t("Trojičné námestie")}</Radio>
            <Radio value={`train`}>{t("Železničná stanica")}</Radio>
            <Radio value={`bus`}>{t("Autobusová stanica")}</Radio>
          </Radio.Group>
        </div>
      ) : (
        ""
      )}
      <div className={styles.map}>
        <Map
          googleMapURL={GOOGLE_MAPS_URL}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={containerElement}
          mapElement={<div style={{ height: `100%` }} />}
          markers={markers}
          mapCenter={mapCenter}
          directionsOrigin={directionsOrigin}
          isSrandon={isSrandon}
        />
      </div>
      {showDownload ? (
        <a
          className={styles.download}
          onClick={() => {
            window.print();
          }}
        >
          <DownloadOutlined /> {t("Stiahnuť mapu")}
        </a>
      ) : (
        ""
      )}
    </>
  );
};

export default ProductMap;
